// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__lRLBh","loader":"Loader_loader__ELmfA","spin":"Loader_spin__lTeNw"};